var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-content" },
    [
      _c("header-inner"),
      _c(
        "wrapper",
        {
          staticClass: "page--top page--bottom",
          attrs: { lineBorders: true, lineCenter: true }
        },
        [
          _c(
            "div",
            { staticClass: "video-container" },
            [
              _c("article-video", {
                attrs: {
                  "youtube-url": "NXtrSE9wLeA",
                  cover: "/images/_tmp/product.jpg"
                }
              })
            ],
            1
          ),
          _c(
            "section",
            { staticClass: "article-description typography-text" },
            [
              _c("h1", { staticClass: "text-blue-2" }, [
                _vm._v("Брендирование входа и кассовой зоны")
              ]),
              _c("p", [
                _vm._v(
                  "Реклама на входе и в кассовой зоне создает «зону доминирования» рекламируемого продукта и обеспечивает\n        гарантированный контакт со всеми покупателями. Брендированные элементы хорошо видны как при входе, так и при\n        выходе из торгового зала. Возможности: рекламные поверхности на разделителях покупок, стикеры на кассовых\n        лентах, продуктовых тележках, брендирование ограждений и антенн безопасности и др.\n      "
                )
              ])
            ]
          ),
          _c("section", { staticClass: "facilities typography-text" }, [
            _c("h1", { staticClass: "text-blue-2 full-width" }, [
              _vm._v("Возможности")
            ]),
            _c("ol", [
              _c("li", [
                _vm._v(
                  "\n          100% контакт со всей аудиторией торговой точки\n        "
                )
              ]),
              _c("li", [
                _vm._v("\n          Стимурирует рост продаж\n        ")
              ]),
              _c("li", [
                _vm._v(
                  "\n          Разнообразные креативные возможности\n        "
                )
              ]),
              _c("li", [
                _vm._v(
                  "\n          Создание зоны доминирования рекламируемого бренда\n        "
                )
              ]),
              _c("li", [
                _vm._v(
                  "\n          Длительный контакт с рекламным сообщением\n        "
                )
              ])
            ])
          ]),
          _c(
            "section",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.slides,
                  expression: "slides"
                }
              ],
              staticClass: "slider-section"
            },
            [
              _c(
                "slider",
                { ref: "slider", attrs: { autoplay: true } },
                _vm._l(_vm.slides, function(slide, id) {
                  return _c("image-slide", {
                    key: id,
                    attrs: { image: slide.image }
                  })
                })
              )
            ],
            1
          ),
          _c("section", { staticClass: "also-interesting" }, [
            _c("h1", { staticClass: "text-blue-2 half" }, [
              _vm._v("Вам может быть интересно")
            ]),
            _c(
              "div",
              { staticClass: "card-list" },
              _vm._l(_vm.newsRelated, function(news) {
                return _c("card-product-small", {
                  key: news.id,
                  attrs: {
                    title: news.title,
                    date: news.date,
                    image: news.image,
                    id: news.id,
                    link: news.url
                  }
                })
              })
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d8d28fa8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d8d28fa8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/products/_category/other.vue
// module id = Z200
// module chunks = 28